import request from '@/util/request';
import qs from 'qs';

export const serviceItemListAll = (params, options) =>
request.get(
  '/api/nursing/serviceItem/listall',
  Object.assign({}, options, { params })
);
// export const add = (params, options) =>
// request.post('/api/v4ward/nursingservicelog/submit', params,options)


export const getList = (params, options) =>
request.get('/api/v4ward/nursingservicelog/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/nursingservicelog/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/nursingservicelog/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/nursingservicelog/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/nursingservicelog/submit', params,options)
